import { render, staticRenderFns } from "./RepostaCardCotacaoHeader.vue?vue&type=template&id=276c8af7"
import script from "./RepostaCardCotacaoHeader.vue?vue&type=script&lang=js"
export * from "./RepostaCardCotacaoHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports